import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import DetailCard, { ICardDetail } from '@/components/common/DetailCard';
import ViewDocumentModal from '@/components/common/ViewDocumentModal';
import Layout from '@/components/Layout/Layout';
import FullPageLoader from '@/components/loader/FullPageLoader';
import BackButton from '@/components/ui/BackButton';
import { ICompany, ICompanyResponse } from '@/interfaces/company.model';
import { IDocument } from '@/interfaces/user.model';
import { showToastNotification } from '@/utility/helper';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
const CompanyDetail: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isViewModal, setIsViewModal] = useState<boolean>(false);
  const { id } = useParams();
  const [companyDetails, setCompanyDetails] = useState<ICompany>();
  const [selectedDocument, setSelectedDocument] =
    useState<Partial<IDocument> | null>(null);
  const getCompanyDetails = async () => {
    setIsLoading(true);
    try {
      const response: ICompanyResponse = await callApi(
        API_URL + API_ENDPOINT.getCompany + '?companyId=' + id,
        { method: 'GET' },
      );
      if (response?.status) {
        setCompanyDetails(response?.data?.company[0]);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getCompanyDetails();
  }, []);
  const toggle = () => {
    setIsViewModal(!isViewModal);
  };
  const handleDocumentClick = (doc: IDocument | string) => {
    const url = typeof doc == 'string' ? doc : doc?.url;
    const docUrl = {
      url,
    };

    setSelectedDocument(docUrl);
    setIsViewModal(true);
  };
  const cardDetails: ICardDetail[] = [
    { label: 'Company Name', value: companyDetails?.name },
    { label: 'Short Name', value: companyDetails?.shortName },
    { label: 'Company Email', value: companyDetails?.email },
    { label: 'Secondary Email', value: companyDetails?.secondaryEmail },
    { label: 'Company Contact Number', value: companyDetails?.phone },
    {
      label: 'Secondary Contact Number',
      value: companyDetails?.secondaryPhone,
    },
    { label: 'GST Number', value: companyDetails?.gst },
    { label: 'Pan Number', value: companyDetails?.pan },
    { label: 'Address', value: companyDetails?.address },
  ];
  return (
    <Layout>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        <>
          {' '}
          <div className="content container-fluid">
            <BackButton label={'Company Detail'} isDetail={true} />
            <DetailCard
              // isLoading={isLoading}
              cardDetails={cardDetails}
              logo={
                companyDetails?.documents?.find(
                  (item) => item?.name === 'Company_Logo',
                )?.url
              }
            />

            <div className="row">
              <DetailCard
                title="Documents"
                documents={companyDetails?.documents}
                // isLoading={isLoading}
                handleDocumentClick={handleDocumentClick}
              />
            </div>
            <div className="row">
              {/* <CardLayout cardStyle=" manage-user-list"> */}
              <DetailCard
                title="Terms & Conditions"
                // isLoading={isLoading}
                ckeditor={true}
                tANDc={companyDetails?.tANDc}
              />
              {/* </CardLayout> */}
            </div>
          </div>
          <ViewDocumentModal
            isOpen={isViewModal}
            toggle={toggle}
            selectedDocument={selectedDocument}
          />
        </>
      )}
    </Layout>
  );
};
export default CompanyDetail;
